import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthSectionComponent } from './components/auth-section/auth-section.component';
import { ContextSectionComponent } from './components/context-section/context-section.component';
import { PublishSectionComponent } from './components/publish-section/publish-section.component';
import { DangerZoneComponent } from './components/danger-zone/danger-zone.component';
import { CalAuthService } from './services/cal-auth.service';
import {
  HeaderComponent,
  NavComponent,
  FooterComponent } from '@cvx/nextpage';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    AuthSectionComponent,
    ContextSectionComponent,
    PublishSectionComponent,
    DangerZoneComponent,
    HeaderComponent,
    FooterComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'DrillPlan Consumption Hub';
  readonly calAuth = inject(CalAuthService);
  
}
